import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "range-input-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
  const _component_FormInput = _resolveComponent("FormInput");
  const _component_Checkbox = _resolveComponent("Checkbox");
  const _component_FormField = _resolveComponent("FormField");
  return _openBlock(), _createBlock(_component_FormField, {
    class: "FormSalary",
    field: _ctx.field
  }, {
    input: _withCtx(() => [_createVNode(_component_van_checkbox_group, {
      modelValue: _ctx.innerValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event)
    }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_ctx.innerIsNegotiable === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_FormInput, {
      modelValue: _ctx.innerMinValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.innerMinValue = $event),
      field: {
        label: '',
        placeholder: '最小金额'
      },
      class: "min-salary",
      type: "digit"
    }, null, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "range-input-line"
    }, "~", -1)), _createVNode(_component_FormInput, {
      modelValue: _ctx.innerMaxValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.innerMaxValue = $event),
      field: {
        label: '',
        placeholder: '最大金额'
      },
      class: "max-salary",
      type: "digit"
    }, null, 8, ["modelValue"])], 64)) : _createCommentVNode("", true), _createVNode(_component_Checkbox, {
      modelValue: _ctx.innerIsNegotiable,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.innerIsNegotiable = $event),
      class: "negotiable"
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("面议", -1)]))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["field"]);
}